/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InsuranceSelectEmployeeDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;
    
    public searchText;

    constructor(private $timeout: any,
                private $q: angular.IQService) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            changeFunc: '&?',
            label: '@?',
            oldItem: '=?',
            canEdit: '=?' ,
        };


        this.template = `
        <md-autocomplete
        md-no-cache="true"
        md-selected-item="value" 
        md-search-text="searchText" 
        md-items="item in findResults(searchText)" 
        md-item-text="item.name"
        md-floating-label="{{label}}"
        md-selected-item-change="selected()"
        ng-disabled="canEdit == false",
        ng-focus="saveObject()">
            <md-item-template>
                <span md-highlight-text="searchText">{{item.name}}</span>
            </md-item-template>
            <md-not-found>
                No matching users were found.
            </md-not-found>
        </md-autocomplete>
        `;
    }

    public link($scope: any, $element: any, attrs: any): any {
        // handle selected item if this field is being passed a previously saved value
        // for this to work it requires that the directive be passed an attribute with 
        // 'id' and 'name' attributes

        // if you want a blank/empty value for md autocomplete then you need to pass it a variable that is undefined. 
        // not an object with undefined value but a regular undefined variable

        // this function is called on change in the input field and returns an array of the matching query results
        $scope.options = [];
        $scope.$watch(() => attrs.val, (n) => {

            if (n !== '') {
                const parseData = JSON.parse(n);
                $scope.options = parseData.filter(data => data);
            }
        });

        $scope.findResults = function(query: any): any {
            var results: any = [];
            $scope.options.forEach(item => {
                if (item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
                    results.push(item);
                }
            });
            return results;
        };    
       
        $scope.saveObject = function (): any {
            // save the original state of the model so you can check if the user has made any changes. 
            if (!$scope.value) {
                $scope.oldItem = {
                    id: undefined,
                    name: undefined
                };
            } else {
                $scope.oldItem = {
                    id: $scope.value.id,
                    name: $scope.value.name
                };
            }
            $scope.saveFunc({args: $scope.value});
        }; 

        //pass information back to controller
        $scope.selected = function (): any {
            if ($scope.value) {
                if ($scope.value.id !== $scope.oldItem.id) {
                    var newObj: any = {
                            name: $scope.value.name,
                            id: $scope.value.id,
                            url: '/api/employees/' + $scope.value.id,
                            email: $scope.value.email,
                        };
                    var oldObj: any = {
                        name: $scope.oldItem.name,
                        id: $scope.oldItem.id,
                        url: '/api/employees/' + $scope.oldItem.id,
                        email: $scope.value.email,
                    };
                    var saveObj: any = {
                        old: oldObj,
                        new: newObj,
                        model: attrs.value
                    };
                    if ($scope.saveFunc) {
                        $scope.saveFunc({args: saveObj});
                    }
                }
            }
        };
    }
    

    public static DirectiveFn(
            $timeout: any,
            $q: angular.IQService
        ): InsuranceSelectEmployeeDirective {
        return new InsuranceSelectEmployeeDirective($timeout, $q);
    }
}

InsuranceSelectEmployeeDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService'];

angular.module('beneple.global').directive('insuranceSelectEmployee', InsuranceSelectEmployeeDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/insurance_endorsement_employee_select.directive.ts